export const getIntents = async (message: string, intents: string[]): Promise<string> => {
  console.log('Getting intents for message:', message);
  console.log('Possible intents:', intents);

  // Mock implementation: return a random intent from the list
  const randomIndex = Math.floor(Math.random() * intents.length);
  const detectedIntent = intents[randomIndex];

  console.log('Detected intent:', detectedIntent);

  return detectedIntent;
};
